import {JS_DATA_MONITOR} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/dataReport/jsDataMonitor/dataMonitor/index.vue'),
    path: 'dataMonitor',
    name: JS_DATA_MONITOR,
    meta: {
        title: 'JS数据监控',
        name: JS_DATA_MONITOR
    }
};